module.exports = __webpack_public_path__ + "static/img/14010794.7eda13a1.png";